import * as React from 'react';
import { styled } from '@glitz/react';
import { getCurrentFlagByCountry } from './deliveryFlags';

type PropType = {
  countryCode: string;
};

const CountryFlag = styled(({ countryCode }: PropType) => {
  const Flag = getCurrentFlagByCountry(countryCode);
  return <Flag css={contryFlagDecorator} />;
});

const contryFlagDecorator = styled({
  margin: { x: '1ch' },
});

export default CountryFlag;
